import { c as _c } from "react/compiler-runtime";
export const RaydiumLogo = t0 => {
  const $ = _c(15);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g clipPath="url(#clip0_8358_5246)"><rect fill="white" height="44" width="44" /><path d="M33.6353 18.2589V28.7197L22 35.4361L10.3582 28.7197V15.2803L22 8.55743L30.9423 13.7229L32.292 12.9442L22 7L9.00842 14.5016V29.4984L22 37L34.9916 29.4984V17.4802L33.6353 18.2589Z" fill="url(#paint0_linear_8358_5246)" /><path d="M18.7423 28.7262H16.7955V22.1979H23.2849C23.8988 22.1912 24.4854 21.9429 24.9177 21.5069C25.3501 21.0709 25.5934 20.4823 25.595 19.8682C25.5985 19.5647 25.5399 19.2635 25.4228 18.9834C25.3055 18.7033 25.1323 18.4502 24.9136 18.2395C24.702 18.022 24.4487 17.8496 24.1688 17.7325C23.8889 17.6153 23.5882 17.556 23.2849 17.558H16.7955V15.5724H23.2913C24.4285 15.5792 25.5173 16.034 26.3215 16.8381C27.1256 17.6423 27.5804 18.7311 27.5872 19.8682C27.5942 20.7388 27.3288 21.5897 26.828 22.3017C26.3672 22.9831 25.7177 23.5153 24.9591 23.8332C24.2079 24.0715 23.4239 24.1897 22.6359 24.1837H18.7423V28.7262Z" fill="url(#paint1_linear_8358_5246)" /><path d="M27.5419 28.5639H25.2706L23.5186 25.5075C24.2117 25.465 24.8955 25.3252 25.5497 25.0922L27.5419 28.5639Z" fill="url(#paint2_linear_8358_5246)" /><path d="M32.2791 16.085L33.6223 16.8313L34.9657 16.085V14.5081L33.6223 13.7294L32.2791 14.5081V16.085Z" fill="url(#paint3_linear_8358_5246)" /></g>;
    t3 = <path d="M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z" stroke="white" strokeOpacity="0.08" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_8358_5246" x1="34.9686" x2="7.41932" y1="14.5099" y2="25.5267"><stop stopColor="#C200FB" /><stop offset="0.489658" stopColor="#3772FF" /><stop offset="0.489758" stopColor="#3773FE" /><stop offset="1" stopColor="#5AC4BE" /></linearGradient>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_8358_5246" x1="34.9685" x2="7.41928" y1="14.5099" y2="25.5267"><stop stopColor="#C200FB" /><stop offset="0.489658" stopColor="#3772FF" /><stop offset="0.489758" stopColor="#3773FE" /><stop offset="1" stopColor="#5AC4BE" /></linearGradient>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <linearGradient gradientUnits="userSpaceOnUse" id="paint2_linear_8358_5246" x1="34.9686" x2="7.41938" y1="14.5099" y2="25.5267"><stop stopColor="#C200FB" /><stop offset="0.489658" stopColor="#3772FF" /><stop offset="0.489758" stopColor="#3773FE" /><stop offset="1" stopColor="#5AC4BE" /></linearGradient>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <linearGradient gradientUnits="userSpaceOnUse" id="paint3_linear_8358_5246" x1="34.9686" x2="7.41935" y1="14.5099" y2="25.5267"><stop stopColor="#C200FB" /><stop offset="0.489658" stopColor="#3772FF" /><stop offset="0.489758" stopColor="#3773FE" /><stop offset="1" stopColor="#5AC4BE" /></linearGradient>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <defs>{t4}{t5}{t6}{t7}<clipPath id="clip0_8358_5246"><path d="M0 22C0 9.84974 9.84974 0 22 0V0C34.1503 0 44 9.84974 44 22V22C44 34.1503 34.1503 44 22 44V44C9.84974 44 0 34.1503 0 22V22Z" fill="white" /></clipPath></defs>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== className || $[12] !== rest || $[13] !== size) {
    t9 = <svg aria-label="Raydium" className={className} fill="none" height={size} viewBox="0 0 44 44" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t2}{t3}{t8}</svg>;
    $[11] = className;
    $[12] = rest;
    $[13] = size;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};